import { createIconComponent } from '../../factory/create-icon-component';
export const SendingLocationIcon = createIconComponent(
  'SendingLocationIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.49976 9.49958V17.2496C2.49976 17.9463 2.49976 18.2947 2.54305 18.5866C2.80157 20.3294 4.17001 21.6978 5.91283 21.9563C6.2047 21.9996 6.55305 21.9996 7.24976 21.9996L9.19157 21.9996M0.999756 10.9996L7.47427 4.52506C9.05834 2.94099 9.85037 2.14896 10.7637 1.85221C11.5671 1.59118 12.4325 1.59118 13.2358 1.85221C14.1491 2.14896 14.9412 2.94099 16.5252 4.52506L22.9998 10.9996"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 17.75L23 17.75M23 17.75L19 13.75M23 17.75L19 21.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
